export default __webpack_public_path__ + "static/media/icw-nav.da8c65a2.jpg";